<template>
  <WildCard v-bind="$attrs" v-on="$listeners" class="students-wild-card">
    <template #promo>
      <div class="students-wild-card__promo">
        <div class="students-wild-card__title">
          Студенческий кубок по dota&nbsp;2
        </div>
        <div class="students-wild-card__description">
          при поддержке Президента Республики Татарстан и Министерства молодёжи
          РТ
        </div>
      </div>
    </template>
  </WildCard>
</template>

<script>
import WildCard from "./WildCard";

export default {
  name: "StudentsWildCard",
  inheritAttrs: false,
  components: {
    WildCard
  }
};
</script>

<style lang="scss">
.students-wild-card {
  &__promo {
    text-align: center;
    max-width: 240px;
    line-height: 1.2;
    margin: 0 auto;
  }
  &__title {
    font-size: 23px;
    color: colors(text-2);
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  &__description {
    font-size: 11px;
    color: darken(#fff, 20%);
  }

  @include breakpoint("md-only") {
  }
}
</style>
